export const FINAL_NOTE_OPTIONS = [
  { label: "Today's data only", value: 'TodaysData' },
  { label: 'Template', value: 'Template' },
  { label: 'Narrative', value: 'Narrative' }
];
